module.exports = __webpack_public_path__ + "static/media/visa.c31ef49b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/credit_cards/visa.svg
// module id = 172
// module chunks = 0